const baseUrl = process.env.VUE_APP_BASE_URL

export { baseUrl }